/*
*
* File JS per la Homepage
*
*/

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

import postModules from 'components/post-modules/post-modules';
import sliderAuthors from 'components/slider-authors/slider-authors';

//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import './homepage.scss';

//--------------------------------------------------------------------//


// INIT COMPONENTI
//--------------------------------------------------------------------//

postModules();
sliderAuthors();

//--------------------------------------------------------------------//